import clsx from 'clsx';
import type { SelectHTMLAttributes } from 'react';

type Option<V extends string> = { value: V; label: string };
type Props<V extends string> = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'value' | 'onChange'> & {
  label: string;
  value: V;
  options: readonly Option<V>[];
  hint?: string;
  onValueChange: (v: V) => void;
};

export function Select<V extends string>({ label, value, options, hint, onValueChange, className, ...rest }: Props<V>) {
  return (
    <label
      className={clsx('flex flex-col gap-1 text-sm', className)}
      {...(hint !== undefined ? { title: hint } : {})}
    >
      <span className="flex items-center gap-1 text-neutral-400">
        {label}
        {hint !== undefined && (
          <span aria-hidden="true" className="text-neutral-500 text-[10px] cursor-help">?</span>
        )}
      </span>
      <select
        value={value}
        onChange={(e) => onValueChange(e.target.value as V)}
        className="bg-neutral-800 text-neutral-100 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-neutral-500"
        {...rest}
      >
        {options.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}
      </select>
    </label>
  );
}
